(function (root, factory) {
    // UMD/AMDWeb module bolierplate: https://github.com/umdjs/umd/blob/master/templates/amdWeb.js
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('DetailModal', ['ModalWindow'], factory);
    } else {
        // Browser globals
        root.DetailModal = factory(root.ModalWindow);
    }
}(this, function (ModalWindow) {
    'use strict';

    if (typeof (ModalWindow) !== 'function') {
        throw new ReferenceError('DetailModal component depends on ModalWindow');
    }

    function Modal(element) {
        this.container = element;

        if (!this.container) return;

        this.content = this.container.querySelector('[data-content]');

        if (!this.content) return;

        this.modal = new ModalWindow(this.container);

        this.onclick = this.onclick.bind(this);
        this.onload = this.onload.bind(this);
        this.onresponse = this.onresponse.bind(this);
        this.readymodal = this.readymodal.bind(this);

        var id = this.container.id;
        this.links = document.querySelectorAll('[data-load-detail="' + id + '"]');

        Array.prototype.forEach.apply(this.links, [function (link) {
            if (!link.getAttribute('href')) return;
            link.addEventListener('click', this.onclick);
        }.bind(this)]);
    }

    Modal.prototype = {
        onclick: function (event) {
            event.preventDefault();
            var target = event.target;
            var href = target.getAttribute('href');

            while (target.getAttribute('data-load-detail') == null) {
                target = target.parentElement;

                if (target == null) {
                    return;
                }

                href = target.getAttribute('href');
            }

            href += '&useAjax=true';

            this.readymodal();

            fetch(href, { credentials: 'include' }).then(this.onresponse).then(this.onload).catch(console.warn);
        },
        onload: function (html) {
            this.content.innerHTML = html;

            var close = this.content.querySelectorAll('[data-close-modal]');

            Array.prototype.forEach.apply(close, [function (el) {
                el.addEventListener('click', function (event) {
                    event.preventDefault();
                    this.modal.close();
                }.bind(this));
            }.bind(this)]);

            this.container.classList.remove('-loading');
        },
        onresponse: function (response) {
            if (!response.ok) {
                return Promise.reject(response);
            }
            return response.text();
        },
        readymodal: function () {
            if (this.content) {
                this.container.classList.add('-loading');
                this.content.innerHTML = '';
            }
            this.modal.open();
        }
    }

    return Modal;
}));
